import { createFacade } from './facade.js';
import './global.js';

const createBrowserMicroAgent = (...args) => {
  const loader = async () => {
    if (typeof window !== "undefined") {
      try {
        const importModule = window.__vpMicroAgentRegister?.import;
        if (!importModule) {
          throw new Error("MicroAgent import helper not found on window.__vpMicroAgentRegister");
        }
        return await importModule();
      } catch (error) {
        console.error("MicroAgent failed to load", error);
        return null;
      }
    } else {
      return null;
    }
  };
  const facade = createFacade(args, () => loader());
  return new Proxy({}, {
    get: (target, prop) => {
      const proxyMethod = facade.proxyMethod(prop);
      if (proxyMethod) {
        return (...args2) => {
          return proxyMethod(...args2).catch(() => {
            return void 0;
          });
        };
      }
    }
  });
};

export { createBrowserMicroAgent };
